import { associationModule } from "./association/index.js";
import { hospitaliteModule } from "./hospitalite/index.js";
export const MODULES = [associationModule, hospitaliteModule];
/**
 * The registry widened for iteration. The narrow tuple above is what the
 * key types derive from; its element is `never` while no module is
 * registered, so every registry that *folds* over the modules reads them
 * through here instead.
 */
export const REGISTERED_MODULES = MODULES;
export { hasGrantPath, packClassMismatches } from "./types.js";
//# sourceMappingURL=index.js.map